const features = [
  {
    icon: 'ri-line-chart-line',
    title: 'Giá vàng thời gian thực',
    desc: 'Cập nhật giá vàng SJC, PNJ, DOJI, vàng nhẫn 9999 liên tục từ thị trường.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Giao dịch minh bạch',
    desc: 'Mua bán vàng trực tuyến với mức giá khớp lệnh rõ ràng, không phí ẩn.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Bảo mật an toàn',
    desc: 'Xác minh danh tính (KYC) và mã hóa dữ liệu bảo vệ tài khoản của bạn.',
  },
  {
    icon: 'ri-bank-line',
    title: 'Nạp rút nhanh chóng',
    desc: 'Liên kết ngân hàng, nạp và rút tiền dễ dàng với thời gian xử lý nhanh.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Tối ưu mọi thiết bị',
    desc: 'Trải nghiệm mượt mà trên máy tính, máy tính bảng và điện thoại.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Hỗ trợ 24/7',
    desc: 'Đội ngũ hỗ trợ tận tâm sẵn sàng giải đáp mọi thắc mắc của bạn.',
  },
];

export default function Features() {
  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6 py-10 md:py-20">
      <div className="text-center mb-6 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">Vì sao chọn <span className="text-gold-gradient">Goldsbvvn</span>?</h2>
        <p className="mt-2 md:mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">Nền tảng được xây dựng để mang lại trải nghiệm đầu tư vàng an toàn, thuận tiện và minh bạch.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
        {features.map((f) => (
          <div
            key={f.title}
            className="rounded-xl border border-background-200/60 bg-background-100 p-4 md:p-6 hover:border-primary-500/40 transition-colors"
          >
            <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-500/15 flex items-center justify-center mb-3 md:mb-4">
              <i className={`${f.icon} text-primary-400 text-lg md:text-xl`}></i>
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground-950">{f.title}</h3>
            <p className="mt-1.5 md:mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}